import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/authContext";
import DashboardContainer from "../pages/Dashboard/DashboardContainer";

function PrivateRoute() {
  const { user } = useAuthContext();

  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardContainer>
      <Outlet />
    </DashboardContainer>
  );
}

export default PrivateRoute;
